var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c(
          "div",
          { staticClass: "card", attrs: { id: "stock-total-review-card" } },
          [
            _c("header", { staticClass: "card-header" }, [
              _c("p", { staticClass: "card-header-title has-text-grey" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("customer.stock.summary.review")) + " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "content" }, [
                _c("dl", [
                  _c("dt", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "customer.stock.summary.crates_consignee_plant"
                          )
                        ) +
                        " : "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.total))]),
                  ]),
                  _c(
                    "dt",
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "customer.stock.summary.crates_customer_plant"
                            )
                          ) +
                          " : "
                      ),
                      _c("strong", [_vm._v(_vm._s(_vm.customerStockCount))]),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              path: "stock/detail",
                              query: { customerId: _vm.selectedCustomer },
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.detail")) + " ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        {
          staticClass: "column is-12",
          attrs: { id: "stock-total-tab-container" },
        },
        [
          _c(
            "b-field",
            { attrs: { grouped: "" } },
            [
              _c("gridManager", {
                attrs: { "grid-id": _vm.gridId, profiles: _vm.gridProfiles },
                on: {
                  save: _vm.saveProfile,
                  create: _vm.createProfile,
                  update: _vm.updateProfile,
                  select: _vm.selectProfile,
                  delete: _vm.deleteProfile,
                },
              }),
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        "icon-left": "globe",
                        type: "is-primary",
                        loading: _vm.isLoadingGlobalExport,
                      },
                      on: { click: _vm.globalExport },
                    },
                    [_vm._v(" Global export ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("ag-grid-vue", {
            staticClass: "ag-theme-alpine",
            staticStyle: { width: "100%", height: "700px" },
            attrs: {
              id: _vm.gridId,
              "row-data": _vm.filteredEndusers,
              "grid-options": _vm.gridOptions,
              pagination: true,
              "pagination-auto-page-size": true,
              "side-bar": ["columns"],
              "get-context-menu-items": _vm.getContextMenuItems,
              "multi-sort-key": "ctrl",
              "enable-range-selection": true,
              "enable-charts": true,
              modules: _vm.modules,
            },
            on: { "grid-ready": _vm.gridReady },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }